import { connect } from 'react-redux';
import ImageLibrary from '../components/ImageLibrary';
import { compose, lifecycle } from 'recompose';
import { checkPermission } from 'utils/credentials';

import _ from 'lodash';

import { fetchLeagueList, fetchTeamsList, clearTeamsList } from '../modules';
import { ROLES } from '../../../../consts';

const mapStateToProps = state => {
  return {
    updateN: _.get(state, 'imageLibrary.updateN', 0),
    apiList: _.get(state, 'imageLibrary.apiList', []),
    teamList: _.get(state, 'imageLibrary.teamList', []),
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const mapDispatchToProps = dispatch => ({
  fetchLeagueList() {
    dispatch(fetchLeagueList());
  },
  updateSelect(leagueId) {
    dispatch(clearTeamsList());
    if (leagueId !== null) {
      dispatch(fetchTeamsList(leagueId));
    }
  },
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchLeagueList();
    },
    componentDidUpdate() {
      checkPermission(this, ROLES.IMAGELIBRARY);
    },
  })
);

export default enhance(ImageLibrary);
